//https://github.com/nuxt/nuxt/issues/26565
//fixes https://sentry.io/organizations/stonexbullion-gmbh/issues/6018999186/?environment=prod&project=6259262&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&statsPeriod=30d&stream_index=1

export default defineNuxtPlugin(() => {
    const router = useRouter()

    if (process.env.NODE_ENV === 'development') {
        // Mode 1
        router.onError((error) => {
            if (error.message.includes('Failed to fetch dynamically imported module')) {
                window.location.reload()
            }
            if (error.message.includes('error loading dynamically imported module')) {
                window.location.reload()
            }
        })

        /*
        // Mode 2
        context.hook('app:chunkError', () => {
          window.location.reload()
        })
        */

        /*
        // Mode 3
        context.hook('app:error', (error) => {
          if (error.message.includes('Loading chunk')) {
            window.location.reload()
          }
        })
        */
    }
})
